import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import useEffectOnce from '@rio-cloud/rio-uikit/useEffectOnce';
import { FlagsProvider } from 'react-feature-flags';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { Outlet } from 'react-router';
import { Upselling } from '../../components/Upselling/Upselling';
import { config } from '../../configuration/config';
import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import { fetchHereSettings } from '../../features/fetchData/fetchHereSettings';
import { loadProfiles } from '../../features/fetchData/loadProfiles';
import { useAccountSubscription } from '../../hooks/AccountSubscriptionHooks';
import { useFeatureToggles } from '../../hooks/useFeatureToggles';
import { useWidgetListener } from '../../hooks/widgetHooks';
import { DefaultRedirect } from '../../routes/DefaultRedirect';
import { selectDisplayMessages, selectLocale } from '../../store/lang/langSelectors';
import { sendMessage } from '../../store/widget/widgetMessaging';
import { widgetActions } from '../../store/widget/widgetSlice';

export const AppLayout = () => {
    const userLocale = useAppSelector(selectLocale);
    const displayMessages = useAppSelector(selectDisplayMessages);
    const dispatch = useAppDispatch();
    const { subscribed, isLoading } = useAccountSubscription();
    const { featureFlags } = useFeatureToggles();
    useWidgetListener();

    useEffectOnce(() => {
        sendMessage(widgetActions.widgetLoaded());
        dispatch(fetchHereSettings);
        dispatch(loadProfiles);
    });

    return (
        <IntlProvider
            defaultLocale={config.login.defaultLocale}
            key={userLocale}
            locale={userLocale}
            messages={displayMessages}
        >
            <FlagsProvider value={featureFlags}>
                <ApplicationLayout data-testid='app-layout'>
                    <NotificationsContainer />
                    {isLoading ? (
                        <div className='display-flex flex-column height-100vh' data-testid='app-layout-spinner'>
                            <Spinner
                                show
                                isFullSized
                                text={<FormattedMessage id='intl-msg:smartRoute.generic.loading' />}
                            />
                        </div>
                    ) : (
                        <>
                            {subscribed?.srpSubscribed && (
                                <div className='display-flex flex-column height-100vh' data-testid='app-layout-content'>
                                    <Outlet />
                                </div>
                            )}
                            {!subscribed?.srpSubscribed && <Upselling />}
                        </>
                    )}
                    <DefaultRedirect />
                </ApplicationLayout>
            </FlagsProvider>
        </IntlProvider>
    );
};
